<div class="row cdinotes mt-3 mb-3">
  <div class="col-md-6">
    <div class="gray-bg-rounded">
      <div class="notesinner">
        <h2 class="mb-0">AP Notes</h2>
        <div class="ap-notes-list-container">
          <ul *ngFor="let note of cdiNotesGridListing" class="mt-2">
            <li class="bigger-font" *ngIf="!!note.notesD365" class="mb-0 pb-0">
              {{ note.notesD365 }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-6">
    <div class="gray-bg-rounded">
      <div class="quicknotes">
        <h2 class="mb-2">
          Quick Notes<span class="madatory-field" *ngIf="quickNotesMandatory"
            >*</span
          >
        </h2>
        <textarea
          name=""
          pInputText
          id=""
          cols="30"
          rows="10"
          [(ngModel)]="quickQuote"
          (change)="onQuickQuoteChange()"></textarea>

        <!-- <button type="button marginleft-auto" (click)="onQuickQuote()">
            Submit
          </button> -->

        <p-button
          label="Submit"
          [ngClass]="{ disableSubmitbtn: quickQuote.trim() === '' }"
          [disabled]="quickQuote.trim() === ''"
          (click)="onQuickQuote()" />
      </div>
    </div>
  </div>
</div>
